export default __webpack_public_path__ + "static/media/HN.17892522.svg";